import React from "react";
import useFailures from "./Failures.hook";
import { FILTERS } from "./Failures.consts";
import HyroTableContainer from "@hyro-components/hyro-table-container/HyroTableContainer";

const Failures = () => {
  const {
    columns,
    failures,
    isLoading
  } = useFailures();

  return (
    <HyroTableContainer
      columns={columns}
      data={failures}
      header={{
        showDownloadButton: false
      }}
      filters={{
        initialFilters: FILTERS
      }}
      pagination={{
        showPagination: true
      }}
      table={{
        loading: isLoading
      }}
    />
  );
};

export default Failures;
